import {fetchTransaction, fetchTransactionSettings} from '@components/Transaction/transactionSlice';
import fetchCommonRefs from './fetchCommonRefs';

export default function fetchTransactionPage({
    store, headers, baseUrl, params, options
}) {
    return [
        store.dispatch(fetchTransaction({headers, params, options})),
        store.dispatch(fetchTransactionSettings({headers, options})),
        ...fetchCommonRefs({
            store, headers, baseUrl, options
        })
    ];
}
